<template>
<div>
    <!-- 左文有图 -->
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="(item, index) in (this.form === 'PC' ? allListMsg.data : newsListMsg.data)" :key="index" class="flex-r flex-btw wrap van-hairline--top" @click="checkDetail(item)">
            <div class="left flex-c">
                <p class="title">{{ item.title }}</p>
                <p class="original" v-if="item.keyword">{{ item.keyword }}</p>
                <p class="time" v-if="item.newstime">{{ item.newstime }}</p>
            </div>
<!--            <van-image class="flex-n right" width="1.7rem" height="1.35rem" fit="contain" :src="item.img_url | proxyImgUrl" />-->
            <van-image class="flex-n right" width="1.7rem" height="1.35rem" fit="contain" :src="item.img_url" />
        </div>
    </van-list>
</div>
</template>

<script>
import config from './../utils/config.js'
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {
            loading: false,
            finished: false,

            form: ''
        }
    },
    props: {
        list: {
            type: Array
        }
    },
    beforeCreate() {
        this.$store.dispatch('cleanNewsListApi');
    },
    created() {
        this.form = this.$route.query.form;
        if (this.form === 'PC') {
            this.$store.dispatch('getAllListApi');

        } else {
            this.$store.dispatch('getNewsListApi');
        }
    },
    computed: {
        ...mapGetters([
            'newsListMsg',
            'allListMsg'
        ])
    },
    methods: {
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                // for (let i = 0; i < 10; i++) {
                //     this.list.push(this.list.length + 1);
                // }
                // 加载状态结束
                this.loading = false;
                this.finished = true;

                // 数据全部加载完成
                // if (this.list.length >= 40) {
                //     this.finished = true;
                // }
            }, 500);
        },
        checkDetail(val){
            if (val.redirect_url) {
                window.location.href = val.redirect_url;
            } else {
                this.$router.push({ path: '/new', query: {newId: val.id}});
            }
        }
    },
    filters: {
        proxyImgUrl(url) {
            let domain = config.imgDomain;
            let imgurl = '';
            let startIndex = 0;
            url = url.split('//')[1];
            startIndex = url.indexOf('/');
            imgurl = url.substring(startIndex);
            return domain + imgurl;
        }
    },
    destoryed () {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap{
    width: 100%;
    box-sizing: border-box;
    padding: 20px 30px 12px;
    min-height: 130px;
    .left{
        width: 500px;
        .title{
            font-size: 32px;
            // font-weight: bolder;
            word-wrap: break-word;
            margin-bottom: 15px;
        }
        .original{
            font-size: 30px;
            line-height: 48px;
        }
        .time{
            font-size: 24px;
            color: #A9A9A9;
        }
    }
    .right{
        border-radius: 8px;
        overflow: hidden;
    }
}
</style>
